import React from 'react'
import { ReactComponent as IconNotFound } from 'images/icons/search/notFound.svg';
import styles from './styles.module.scss'

type Props = {
  text?: string
}

export default function NotFound({ text }: Props) {
  return (
    <div className={styles.notFoundContainer}>
      <IconNotFound className={styles.notFound} />
      <h4>Not available</h4>
      <span>{text || 'Unfortunately, this asset is not available, but you can request it'}</span>
    </div>
  )
}
